import { UsersService } from 'data/services/users';
import { UsersServiceInterface } from 'domain/services/users';
import { makeRemoteCreateUser } from 'main/factories/usecases/Users/create-user-factory';
import { makeRemoteDeleteUser } from 'main/factories/usecases/Users/delete-user-factory';
import { makeRemoteGetAllUsers } from 'main/factories/usecases/Users/get-all-users-factory';
import { makeRemoteGetUserByCpf } from 'main/factories/usecases/Users/get-user-by-cpf-factory';
import { makeRemoteGetUserById } from 'main/factories/usecases/Users/get-user-by-id-factory';
import { makeRemoteUpdateUser } from 'main/factories/usecases/Users/update-user-factory';
import { makeRemoteGetUsersOnline } from 'main/factories/usecases/Users/users-online/get-users-online';
import { makeRemoteGetUsersOnlineMaps } from 'main/factories/usecases/Users/users-online/get-users-online-maps';

export const makeUsersService = (): UsersServiceInterface => {
  return new UsersService({
    getAllUsers: makeRemoteGetAllUsers(),
    createUser: makeRemoteCreateUser(),
    updateUser: makeRemoteUpdateUser(),
    deleteUser: makeRemoteDeleteUser(),
    getUserById: makeRemoteGetUserById(),
    getUserByCpf: makeRemoteGetUserByCpf(),
    getUsersOnline: makeRemoteGetUsersOnline(),
    getUsersOnlineMaps: makeRemoteGetUsersOnlineMaps(),
  });
};
